// A code that came with a link (e.g. the reorder e-mail's "Buy again": /product/serum?coupon=AGAIN10). It is kept
// until the bag has something in it, then applied once by CartContext — whether it works or not, it is not retried.

const KEY = 'skinnthrive_pending_coupon';
const KEEP_MS = 7 * 24 * 60 * 60 * 1000;

const safe = (fn, fallback) => {
  try { return fn(); } catch { return fallback; }
};

/** Remembers ?coupon= from a URL query string; returns the code, or null when there is none. */
export const rememberCouponFromSearch = (search) => {
  const code = safe(() => new URLSearchParams(search).get('coupon'), null);
  const clean = code ? code.trim().toUpperCase().slice(0, 100) : '';
  if (!clean || !/^[A-Z0-9_-]+$/.test(clean)) return null;
  safe(() => localStorage.setItem(KEY, JSON.stringify({ code: clean, savedAt: Date.now() })));
  return clean;
};

/** The remembered code, or null (none, or older than a week). */
export const pendingCoupon = () => {
  const saved = safe(() => JSON.parse(localStorage.getItem(KEY) || 'null'), null);
  if (!saved?.code) return null;
  if (!saved.savedAt || Date.now() - saved.savedAt > KEEP_MS) {
    clearPendingCoupon();
    return null;
  }
  return saved.code;
};

export const clearPendingCoupon = () => safe(() => localStorage.removeItem(KEY));
